import { render } from "./HomeQuestions.vue?vue&type=template&id=1a29ac16&scoped=true&ts=true&lang=pug"
import script from "./HomeQuestions.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeQuestions.vue?vue&type=script&lang=ts&setup=true"

import "./HomeQuestions.vue?vue&type=style&index=0&id=1a29ac16&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a29ac16"]])

export default __exports__